import { TenantId } from './tenant-ids'
import type { TenantConfig } from './tenant-config'
import { tenants } from './tenant-config'
import type { TenantLogos } from './tenant-logos'
import tenantLogos from '@tenant-assets/logos'

// Re-export the tenant types + the raw map for convenience. The authored data
// lives in `tenant-config.ts` (node-safe so `set-tenant.ts` can generate logos
// from it); this module resolves the single active `tenant` for the app.
export * from './tenant-config'

let tenantId = 'demo'
if (typeof __TENANT__ !== 'undefined') {
	tenantId = __TENANT__ as TenantId
}
// Read tester mode straight from storage rather than importing utils/tester-mode,
// which imports `tenant` from this module and would create a circular dependency
// (TDZ "Cannot access 'isTesterMode' before initialization"). Key mirrors the
// StoredBooleanSubject('isTesterMode') in utils/tester-mode.
const testerModeActive = typeof localStorage !== 'undefined' && localStorage.getItem('isTesterMode') === 'true'
if (testerModeActive) {
	tenantId = 'demo'
}

// Logo assets are bundled per-tenant via the `@tenant-assets` Vite alias, which
// resolves to the active tenant's folder. The active tenant's `logos.ts` is
// generated from `logoLargeFile`/`logoSmallFile` by `scripts/set-tenant.ts`.
export const tenant: TenantConfig & TenantLogos = {
	...tenants[tenantId],
	...tenantLogos
}
